<mat-form-field [appearance]="appearance">
  <mat-label>{{ label }}</mat-label>
  <input
    matInput
    type="{{ type }}"
    placeholder="{{ placeholder }}"
    [(ngModel)]="value"
    (ngModelChange)="valueChange.emit(value)"
    [disabled]="disabled"
  />
  <ng-content></ng-content>
</mat-form-field>
